import { PopoverButton } from '@headlessui/react';
import { useAtomValue } from 'jotai';

import { datepickerInputValueAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import type { InputProps } from '@/components/base/Input';
import Input from '@/components/base/Input';
import type { PopoverChildrenProps } from '@/components/base/Popover';

type DatepickerInputProps = Pick<PopoverChildrenProps, 'setReferenceElement'> & InputProps;

export function DatepickerInput({ setReferenceElement, ...restProps }: DatepickerInputProps) {
    const datepickerValue = useAtomValue(datepickerInputValueAtom);

    return (
        <PopoverButton
            data-testid="datepicker-input-button"
            className="w-full rounded-md focus:ring-offset-0"
            ref={setReferenceElement}>
            <Input
                data-testid="datepicker-input"
                defaultValue={datepickerValue}
                key={datepickerValue}
                inputStyle="datepicker"
                readOnly
                {...restProps}
            />
        </PopoverButton>
    );
}
